






































import { ClassifiedBackgroundJobs } from '~/models/background-jobs/types'
import ClassifiedBackgroundJobInfo from '~/components/car/classifieds/search/results/rows/main/partials/BackgroundJobs/ClassifiedBackgroundJobInfo.vue'
import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { ciCheckCircle } from '~/icons/source/solid/check-circle'
import { ciExclamationTriangle } from '~/icons/source/solid/exclamation-triangle'
import CPopover from '~/components/shared/configurable/CPopover.vue'

export default defineComponent({
  components: { CPopover, ClassifiedBackgroundJobInfo },
  props: {
    jobs: {
      type: Object as PropType<ClassifiedBackgroundJobs>,
      required: true
    }
  },
  computed: {
    icons() {
      return {
        check: ciCheckCircle,
        exclamationTriangle: ciExclamationTriangle
      }
    },
    allSucceeded() {
      return (
        this.jobs.succeed.length &&
        (!this.jobs.failed || this.jobs.failed.length === 0)
      )
    },
    allFailed() {
      return (
        this.jobs.failed.length &&
        (!this.jobs.succeed || this.jobs.succeed.length === 0)
      )
    },
    someSucceeded() {
      return this.jobs.succeed.length && this.jobs.failed.length
    },
    statusIcon() {
      if (this.allSucceeded) {
        return this.icons.check
      }
      return this.icons.exclamationTriangle
    }
  }
})
